import type { AxiosInstance, AxiosResponse } from 'axios';
import type { Statistic, StatisticAnswer } from '@/models/statistic';

export type GetStatistics = {
   surveyId: string;
   startDate: string;
   endDate: string;
};

type GetStatisticsQuestions = {
   surveyId: string;
};

export type GetAnswerStatistics = {
   surveyId: string;
   body: { questions: string[] };
};

class StatisticsService {
   private provider: AxiosInstance;

   constructor(provider: AxiosInstance) {
      this.provider = provider;
   }

   async getStatistics({
      surveyId,
      startDate,
      endDate,
   }: GetStatistics): Promise<Record<string, number>> {
      const response: AxiosResponse<Record<string, number>> =
         await this.provider.get(
            `/surveys/${surveyId}/entry/count-from-first`,
            {
               params: {
                  start_date: startDate,
                  end_date: endDate,
               },
            },
         );

      return response.data;
   }

   async getStatisticsQuestions({
      surveyId,
   }: GetStatisticsQuestions): Promise<Statistic[]> {
      const response: AxiosResponse<Statistic[]> = await this.provider.get(
         `/statistics/answers-question?survey_id=${surveyId}`,
      );

      return response.data;
   }

   async getAnswerStatistics({
      surveyId,
      body,
   }: GetAnswerStatistics): Promise<StatisticAnswer[]> {
      const response: AxiosResponse<StatisticAnswer[]> =
         await this.provider.post(
            `/statistics/answers-question-conditions?survey_id=${surveyId}`,
            body,
         );

      return response.data;
   }
}

export default StatisticsService;
